import React from 'react';
import styles from "./Footer.module.css";
import logo from "../../assets/images/logo.png";
import { useNavigate, useLocation } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        const headerOffset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    } else {
      navigate(`/#${sectionId}`);
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const headerOffset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  };

  const sectionIds = {
    'О нас': 'about',
    'Услуги': 'services', 
    'Кейсы': 'cases'
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.logoWrapper}>
          <img src={logo} alt="Logo" className={styles.logo} />
        </div>
        <div className={styles.contacts}>
          <p>
            +7 (906) 122-57-57<br/>
            info@detail-delivery.com<br/>
            Ленинградская ул. 25, Химки
          </p>
        </div>
        <nav className={styles.nav}>
          <button 
            className={styles.navLink} 
            onClick={() => scrollToSection(sectionIds['О нас'])}
          >
            О нас
          </button>
          <button 
            className={styles.navLink} 
            onClick={() => scrollToSection(sectionIds['Услуги'])}
          >
            Услуги
          </button>
          <button 
            className={styles.navLink} 
            onClick={() => scrollToSection(sectionIds['Кейсы'])}
          >
            Кейсы
          </button>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;